module.exports = __webpack_public_path__ + "static/media/portada1440_900_ escritorio_medio.9a38dd63.png";